import { createAction } from '../../../core/helpers'

import { FETCH_CUISINE_TYPE } from '../action-types'

export const cleanupFetchCuisineType = createAction(FETCH_CUISINE_TYPE.CLEANUP)
